<template>
    <el-container>
        <el-main style="padding: 0; margin-top: 5px;">
          <!--底部样式-->
          <el-container direction="vertical" style="overflow-x: hidden">
            <el-row>
              <el-col :span="24">
                <div class="list">
                  <HeaderBar :title="barTitle">
                    <el-form class="search" inline :model="searchForm" ref="searchForm" label-width="100px">
                      <el-form-item prop="keywords" style="width: 23%">
                        <el-input v-model="searchForm.keywords" placeholder="请输入公告标题"></el-input>
                      </el-form-item>
    
                      <el-form-item prop="catalogId" style="width: 23%">
                        <el-input v-model="searchForm.catalogId" placeholder="请输入公告分类"></el-input>
                      </el-form-item>
                      <el-form-item prop="date" style="width: 35%">
                        <el-date-picker
                          v-model="date"
                          type="daterange"
                          value-format="yyyy-MM-dd"
                          range-separator="至"
                          start-placeholder="发布开始日期"
                          end-placeholder="发布结束日期">
                        </el-date-picker>
                      </el-form-item>
                      <el-form-item>
                        <el-button type="primary" @click="onSearch('searchForm')">查询</el-button>
                        <el-button @click="resetForm('searchForm')">重置</el-button>
                      </el-form-item>
                    </el-form>
                  </HeaderBar>
                  <div class="list-card">
                    <el-table
                      :data="lists"
                      :row-style="rowStyle"
                      :cell-style="cellStyle"
                      :show-header="true"
                      max-height="380px"
                      @row-click="handleRowClickEvent"
                      v-loading="loading"
                    >
                      <el-table-column prop="title" label="公告标题" show-overflow-tooltip align="left">
                      </el-table-column>
                      <el-table-column prop="" label="公告类型" width="180" align="left"> 
                        <template slot-scope="scope">
                         <span >{{scope.row.catalog.name}}</span>
                        </template> 
                      </el-table-column>
                      <el-table-column prop="createDate" label="发布日期" width="120" align="left"><template slot-scope="scope">{{renderDate(scope.row.releaseDate)}}</template></el-table-column>
                    </el-table>
                    <el-divider></el-divider>
                    <el-pagination
                      :background="true"
                      layout="prev, pager, next"
                      :total="totalElements"
                      :current-page="pageNo"
                      @current-change="handleSizeChangeEvent"
                    >
                    </el-pagination>
                  </div>
                </div>
              </el-col>
            </el-row>
          </el-container>
        </el-main>
      </el-container>
    </template>
    <script>
      import * as dayjs from 'dayjs';
      import HeaderBar from '@/components/HeaderBar.vue';
      import { prefixedUrlAsset } from '@/utils/constants';
      export default{
        name: 'PublicityList',
        components: { HeaderBar },
        data() {
          return {
            lists: [],
            barTitle: '站内搜索',
            pageNo: 1,
            pageSize: 10,
            totalElements: 0,
            title: '',
            loading: false,
            searchForm: {
              keywords: '',
              catalogId: '',
            },
            date: [],
          }
        },
        mounted() {
          let keywords = this.$route.query.keywords;
          if(keywords){
            this.searchForm.keywords = keywords+'';
          }
          this.getSearchList();
        },
        methods: {
          cellStyle() {
            return 'padding: 0px; font-size:14px; height: 32px; border: none; cursor: pointer;';
          },
          rowStyle() {
            return 'white-space: nowrap;';
          },
          onSearch(formName) {
            this.pageNo = 1;
            this.getSearchList();
          },
          resetForm(formName) {
            this.$refs[formName].resetFields();
            this.date = [];
          },
          getSearchList() {
            console.log(55, this.date)
            const startTime = this.date.length ? this.date[0] : '';
            const endTime = this.date.length ? this.date[1] : '';
            const params = {
              pageNo: this.pageNo,
              pageSize: this.pageSize,
              ...this.searchForm,
              startTime,
              endTime,
            };
            this.loading = true;
    
            this.axios.post(`${prefixedUrlAsset}/pub/news/basicInfo/list`, params).then((({ data })=> {
              if (data.code == 0) {
                this.loading = false;
                this.lists = data.data.content;
                this.totalElements = data.data.totalElements;
              }
            }))
          },
          renderDate(val) {
            return dayjs(val).format('YYYY-MM-DD')
          },
          handleSizeChangeEvent(page) {
            this.pageNo = page;
            this.getSearchList();
          },
          handleRowClickEvent(row) {
            this.$router.push({ path: 'detail/'+row.id });
          },
        }
      }
    </script>
    <style lang="scss">
      .list {
        display: flex;
        flex-direction: column;
        justify-content: flex-start;
        align-items: center;
        background-color: white;
        padding: 10px 10px 0px 10px;
        margin-bottom: 20px;
        .list-card {
          display: flex;
          flex-direction: column;
          justify-content: flex-start;
          align-items: flex-start;
          padding: 10px 10px 10px 10px;
          width: 100%;
          background-color: white;
          border-left: 1px solid #DCDCDC;
          border-right: 1px solid #DCDCDC;
          border-bottom: 1px solid #DCDCDC;
          box-sizing: border-box;
          border-radius: 0 0 15px 15px;
        }
        .el-form-item__content {
          width: 100%;
        }
        .el-range-editor.el-input__inner {
          width: 100%;
        }
      }
      .el-pagination.is-background .el-pager li:not(.disabled).active {
        background-color: #026D31;
        color: #FFF;
      }
    </style>
    <style scoped>
      .search {
        padding-left: 10px;
        margin-top: 10px;
      }
      .el-form-item {
        margin-bottom: 0;
      }
      .el-button:hover {
        background: none;
        border-color: #026D31;
        color: #026D31;
      }
      .el-button:focus {
        background: #FFF;
        border: 1px solid #DCDFE6;
        color: #606266;
      }
      .el-button--primary, .el-button--primary:hover, .el-button--primary:focus {
        background: #026D31;
        border-color: #026D31;
        color: #fff;
      }
      .el-button--primary:hover {
       font-weight: bolder;
      }
    
    </style>
    